import { PublicGetUserLoanDetailsResponse } from '@bukalapak/openapi-schema/vptrader/loan/v1/public/loan-domain';
import VPNonTraderAPIClient from '~/api/vpnontrader';

type InitialState = {
  userLoanDetails: PublicGetUserLoanDetailsResponse;
  isLoadingUserLoanDetails: boolean;
  isErrorLoadingUserLoanDetails: boolean;
};

const initialState: InitialState = {
  userLoanDetails: {},
  isLoadingUserLoanDetails: true,
  isErrorLoadingUserLoanDetails: false,
};

const getters = {
  getUserLoanDetails(state) {
    return state.userLoanDetails;
  },
  isLoadingUserLoanDetails(state) {
    return state.isLoadingUserLoanDetails;
  },
  isErrorLoadingUserLoanDetails(state) {
    return state.isErrorLoadingUserLoanDetails;
  },
};

const actions = {
  async fetchUserLoanDetails({ commit, dispatch }) {
    commit('setLoadingUserLoanDetails', true);
    commit('setErrorLoadingUserLoanDetails', false);
    try {
      const response = await VPNonTraderAPIClient.getUserLoanDetails();
      commit('setUserLoanDetails', response);
    } catch (error) {
      commit('setErrorLoadingUserLoanDetails', true);
      dispatch('catchError', { error });
    } finally {
      commit('setLoadingUserLoanDetails', false);
    }
  },
};

const mutations = {
  setUserLoanDetails(state, userLoanDetails) {
    state.userLoanDetails = userLoanDetails;
  },
  setLoadingUserLoanDetails(state, isLoadingUserLoanDetails) {
    state.isLoadingUserLoanDetails = isLoadingUserLoanDetails;
  },
  setErrorLoadingUserLoanDetails(state, isErrorLoadingUserLoanDetails) {
    state.isErrorLoadingUserLoanDetails = isErrorLoadingUserLoanDetails;
  },
};

export default {
  state: () => ({ ...initialState }),
  getters,
  actions,
  mutations,
};
